import styled from 'styled-components'
import { Text } from '@ucheba/ui/components/Text/desktop'

const Image = styled.img`
  width: 20px;
`

const Block = styled.div``

const TextSC = styled(Text)`
  p {
    margin-block-end: 0;
  }
`

export default { Image, Block, TextSC }
